class StateManager {
    private cachedData = {}

    public get(key: string, defaultValue: any = undefined, decourator: any = undefined) {
        let value = this.cachedData[key]
        if (value !== undefined) {
            return value
        }
        value = localStorage.getItem(key)
        if (value === undefined || value === null) {
            this.cachedData[key] = defaultValue
            return defaultValue
        }
        let parseValue = JSON.parse(value)
        if (decourator) {
            parseValue = decourator(parseValue)
        }
        this.cachedData[key] = parseValue
        return parseValue
    }

    public set(key: string, value: any) {
        this.cachedData[key] = value
        localStorage.setItem(key, JSON.stringify(value))
    }

    public delete(key: string) {
        delete this.cachedData[key]
        localStorage.removeItem(key)
    }
}

export default new StateManager()